import React from "react";

function Loader() {
  return (
    <div className="loader">
      <div className="spinner-border text-dark" role="status">
        <span className="sr-only"></span>
      </div>
    </div>
  );
}

export default Loader;
